import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck } from "go-form";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import { parseStringToList } from "../../../utils/utils";

interface Props {
	form: UseFormReturn<ApplicationApi>;
	appState: AppState;
	handleUpdateConfig: (prop: string, obj?: any) => void;
	updatedConfig: Record<string, any> | undefined;
}

const WoltDriveAdvancedForm = ({ form, appState, updatedConfig, handleUpdateConfig }: Props) => {
	const {
		formState: { errors },
		control,
		register,
	} = form;
	const { t } = useTranslation();
	const defaultTerminals = parseStringToList(
		appState.app.settings,
		updatedConfig || {},
		"notification_terminal",
		"notification_terminals"
	)?.map((terminal) => ({
		label: terminal?.name,
		id: terminal?.id,
	}));

	const searchTerminals = (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return apiOrganization.getTerminalsSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};

	return (
		<fieldset className="form-group">
			<h6>{t("lib:common.word.advanced")}</h6>
			<FormSelectGroup
				isMulti
				name="settings.notification_terminal"
				getOptionValue={(option) => option.id}
				onChange={(_, fullObj) => handleUpdateConfig("notification_terminals", fullObj)}
				label={t("modules.app.field.default_terminals.title")}
				errors={errors}
				defaultValue={defaultTerminals}
				loadOptions={searchTerminals}
				control={control}
				data-testid="settings.notification_terminal"
			/>
			<FormCheck
				type="switch"
				register={register}
				label={t("modules.app.field.should_send_sms_notifications.title")}
				name="settings.should_send_sms_notifications"
				errors={errors}
			/>
		</fieldset>
	);
};

export default WoltDriveAdvancedForm;
